export default __webpack_public_path__ + "assets/8f94e2073bdc1c9a4be737de310d01cc.svg";